import { Box, Flex } from '@resideo/blueprint-react';
import { screenBreakpoints } from 'hooks/useMedia';
import styled from 'styled-components';
import { PageDescriptionProps } from './PageLayout.types';

export const ParentContainer = styled(Flex)`
  flex-direction: row;
  justify-content: center;
`;

export const CenteredContainer = styled(Flex)`
  flex-direction: column;
  padding: 0 1.5rem;
  width: 100%;
  max-width: 1360px;
  justify-self: center;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    margin-bottom: 2rem;
  }
  @media screen and (min-width: ${screenBreakpoints.md}) {
    padding: 0 6rem;
  }
`;

export const PageLayoutContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;
`;

export const PageDescription = styled(Box)<PageDescriptionProps>`
  padding-bottom: 24px;
  margin: 0;

  * {
    margin-top: 0;
    margin-bottom: 1rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  ${({ separator = true }) => separator && 'border-bottom: 2px solid #dadada;'}
`;
